import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

/**
 * TODO - Create a parent class for storage service for generalizing Local and 
 *        Cookie storage classes
 */
@Injectable()
export class LocalStorageService {

  static readonly APP_AUTH_ACCESS_TOKEN_KEY = `LAUNCH-AUTH-${environment.storageKeys.auth.accessToken !== "" ? environment.storageKeys.auth.accessToken : 'accessToken'}`;
  static readonly APP_AUTH_REFRESH_TOKEN_KEY = `LAUNCH-AUTH-${environment.storageKeys.auth.refreshToken !== "" ? environment.storageKeys.auth.refreshToken : 'refreshToken'}`;
  static readonly APP_AUTH_REFRESH_TOKEN_EXPIRY_KEY = `LAUNCH-AUTH-${environment.storageKeys.auth.refreshTokenExpiry !== "" ? environment.storageKeys.auth.refreshTokenExpiry : 'refreshTokenExpiry'}`;
  static readonly APP_CURRENT_ORG_KEY = `CURRENT-ORG-${environment.storageKeys.auth.currentOrganization !== "" ? environment.storageKeys.auth.currentOrganization : 'currentOrg'}`;
  static readonly APP_AUTH_ORGS_KEY = `AUTH_ORGS-${environment.storageKeys.auth.authorizedOrganizations !== "" ? environment.storageKeys.auth.authorizedOrganizations : 'authOrgs'}`;
  static readonly APP_REM_KEY = `LAUNCH-REM-${environment.storageKeys.rememberMe !== "" ? environment.storageKeys.rememberMe : 'remEmail'}`;

  /**
   * Sets item in local storage
   *
   * @param {string} key
   * @param {unknown} value
   */
  setItem(key: string, value: unknown) {
    try { // check if item is a json object
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      localStorage.setItem(key, value as string);
    }
  }

  /**
   * Gets item from local storage by key
   *
   * @param {string} key
   * @return {*}  {unknown}
   */
  getItem(key: string): unknown {
    const value = localStorage.getItem(key);
    try {
      return JSON.parse(value as string);
    } catch (e) {
      return value;
    }
  }

  /**
   * Removes item from local storage by key
   *
   * @param {string} key
   */
  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * 
   */
  clear() {
    Object.keys(localStorage)
        .forEach(x => this.removeItem(x))        
  }
}